export const DATE_FILTER = {
    "title": "Date",
    "list": [
        {
          id: "",
          name: "All"
        },
        {
          id: "today",
          name: "Today"
        },
        {
          id: "tomorrow",
          name: "Tomorrow"
        },
        {
          id: "week",
          name: "This Week"
        },
        {
          id: "month",
          name: "This Month"
        },
        {
          id: "custom_range",
          name: "Custom Range"
        }
    ]
}

export const DATE_FORMAT = "YYYY-MM-DD"
export const DATE_SHOW_FORMAT = "dddd, MMMM DD"
export const DEFAULT_LIMIT = 10;
